import React from 'react';
import { ReactQueryDevtools } from 'react-query/devtools';

export const ReactQueryDevToolProvider = ({ children }) => {
  return (
    <React.Fragment>
      {/*<ReactQueryDevtools initialIsOpen={false} position={'bottom-right'} />*/}
      {children}
    </React.Fragment>
  );
};
